import React from 'react';
import { AccountTabContentWrapper } from './AccountTab.style';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { AccountState } from 'src/domains/players/state/accountState/AccountState';

interface AccountTabType {
    children: React.ReactNode;
}

export const AccountTab = observer('AccountTab', (props: AccountTabType) => {
    const { children } = props;
    const common = useCommon();
    const accountState = AccountState.get(common);

    return <AccountTabContentWrapper ref={accountState.setRef}>{children}</AccountTabContentWrapper>;
});
